export const isImportLocal = (importPath: string) => {
	return importPath.startsWith('.')
}
